import { useConfigStore } from '@packages/stores';

import { Assets } from '@assets';
import { Text } from '@elements/text';
import { i18n } from '@i18n';
import { testProps } from '@utils';

import FreelyImage from './images/freely-app.jpg';
import QRcode from './images/qr-code.png';

export const DownloadFreely = () => {
  const APP_STORE_LINK = useConfigStore(state => state.config?.APP_STORE_LINK);
  const PLAY_STORE_LINK = useConfigStore(state => state.config?.PLAY_STORE_LINK);
  return (
    <section
      className="flex flex-col  sm:flex-row p-s16 gap-s20 rounded-2xl bg-surface-warning"
      aria-labelledby="download-freely-title">
      <img
        className="rounded-2xl object-cover w-full sm:w-[47%] md:w-[55%]"
        src={FreelyImage}
        alt="Freely app preview"
        loading="lazy"
        decoding="async"
        sizes="(min-width: 768px) 65vw, (min-width: 640px) 47vw, 100vw"
      />
      <div className="flex flex-col gap-s16 flex-1 my-auto">
        <Text
          {...testProps('confirmation-download-freely')}
          id="download-freely-title"
          variant="subTitle-20/sb">
          {i18n.t('confirmation.downloadFreely')}
        </Text>
        <img
          src={QRcode}
          className="hidden lg:block max-h-[160px] max-w-[160px]"
          alt={'QR code to download Freely app'}
          loading="lazy"
          decoding="async"
        />
        <div className="flex flex-row  gap-s16 sm:justify-normal lg:hidden">
          <a href={PLAY_STORE_LINK} rel="noreferrer">
            <Assets.GooglePlayBadge className="h-[39px]" />
          </a>
          <a href={APP_STORE_LINK} rel="noreferrer">
            <Assets.AppStoreBadge className="h-[39px]" />
          </a>
        </div>
      </div>
    </section>
  );
};
